export const data = [
  {
    name: 'Site 1',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 2',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 3',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 4',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 5',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 6',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 7',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  },
  {
    name: 'Site 8',
    description:
      'Compliance reporting is a crucial aspect of regulatory and legal adherence for organizations across various industries.'
  }
];

export const folders = [
  {
    name: 'Datox file no1',
    type: 'folder',
    size: '9 kb',
    edited_at: '10 days ago'
  },
  {
    name: 'Product roadmap',
    type: 'folder',
    size: '112 kb',
    edited_at: '14 days ago'
  },
  {
    name: 'Locations',
    type: 'folder',
    size: '9 kb',
    edited_at: '2 hours ago'
  },
  {
    name: 'Founders',
    type: 'folder',
    size: '99 kb',
    edited_at: '6 days ago'
  },
  {
    name: 'Curators',
    type: 'folder',
    size: '9 kb',
    edited_at: '10 days ago'
  }
];

export const files = [
  {
    name: 'Excel.xlsx',
    type: 'excel',
    size: '9 kb',
    edited_at: '10 days ago'
  },
  {
    name: 'Employee.pdf',
    type: 'pdf',
    size: '120 kb',
    edited_at: '12 days ago'
  },
  {
    name: 'Roadmap.word',
    type: 'word',
    size: '120 kb',
    edited_at: '12 days ago'
  }
];
